import { render, staticRenderFns } from "./ConfirmSample.vue?vue&type=template&id=63b763bf"
import script from "./ConfirmSample.vue?vue&type=script&lang=js"
export * from "./ConfirmSample.vue?vue&type=script&lang=js"
import style0 from "./ConfirmSample.vue?vue&type=style&index=0&id=63b763bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports